<!--院内资产-->
<template>
    <div class="storageassets-module">
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="store-box flex-start flex-y-center">
                <div @click="showRegionPopup = true" v-if="regionList && regionList.length > 0" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div @click="showRegionStorePopup = true" v-if="(checkedStore.id != '-1') && (regionStoreList && regionStoreList.length > 0)" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div @click="showType = true" class="type-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ typeVal.name || '' }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div class="head-box">
                <div class="title-name">
                    <span>临期产品总数</span>
                    <span>数据更新至{{ storageAssetsList.dateTime }}</span>
                </div>
                <div class="assets flex-y-center">
                    <div class="amount">{{ storageAssetsList.stockOnhandSum || 0 }}</div>
                </div>
            </div>
            <div class="head-chart">
                <div ref="headchart" id="headchart"></div>
            </div>
            <div class="interval"></div>
            <div class="date-box  flex-row  flex-between">
                <div class="date" @click="showMonth = true">
                    <div>{{ checkedMonth.name }}:{{ detailList.stockOnhandSum }} </div>
                    <div :class="{ 'arrow-t': showMonth, 'arrow-b': !showMonth }"></div>
                </div>
                <div class="flex-row flex-y-center">
                    <div class="sort" @click="sortEvt">库存{{ `${sortVal ? '升' : '降'}` }}序</div>
                    <div :class="{ 'arrow-t': sortVal, 'arrow-b': !sortVal }"></div>
                </div>
            </div>
            <div class="dataListWrapper">
                <div class="dataListBox" v-for="(v, k) in detailList.skuList" :key="k">
                    <div class="title">{{ v.prodName }}</div>
                    <div class="desc">
                        <span class="label">离过期{{ checkedMonth.name }}库存数量：</span>
                        <span class="num">{{ v.cnt }}</span>
                    </div>
                </div>
            </div>
        </van-pull-refresh>
        <!-- 选月份 -->
        <van-popup v-model="showMonth" round position="bottom" closeable class="popup">
            <picker title="选择月份" v-model="checkedMonth" :list="monthOpt" @change="changeMonth"></picker>
        </van-popup>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
        <!-- 切换筛选类型 -->
        <van-popup v-model="showType" round position="bottom" closeable class="popup">
            <picker title="选择类型" v-model="typeVal" :list="typeOpts" @change="changeTypeEvt"></picker>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast, ActionSheet } from "vant";
    import { timestampToYestoday, getYear } from '@/utils/validate';
    import { getCookie } from '@/utils'
    import { mapState } from 'vuex'
    import Picker from '@/components/Picker';
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'
    import debounce from 'lodash/debounce'
    export default {
        name: "erpRemind",
        inject: ['reload'],
        components: {
            Picker,
            [ActionSheet.name]: ActionSheet
        },
        data() {
            return {
                year: "",
                storageAssetsList: [],
                refreshing: false,
                updateTime: timestampToYestoday(),   //更新时间
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: 0, name: '' },//所选区域
                checkedStore: {  //所选门店

                },
                dimension: 0, //区分生美医美 1 生美 2 医美
                checkedMonth: {},
                monthOpt: [{ name: '0-3个月', id: 1 }, { name: '4-6个月', id: 2 }, { name: '7-9个月', id: 3 }, { name: '10-12个月', id: 4 }],
                showMonth: false,
                myEcharts: null,
                typeOpts: [
                    { name: '全部', id: 0 },
                    { name: '大库', id: 1 },
                    { name: '客存间', id: 2 },
                ],
                typeVal: {
                    name: '全部',
                    id: 0
                },
                showType: false,
                sortVal: false,  //排序 true升序 false降序
                listLoading: true,
                detailList: []
            };
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                }
            }),
        },
        mounted() {
            this.init()
        },
        methods: {
            async init() {
                try {
                    // 获取当前登陆人所记录的区域门店信息
                    const loginRes = await getUserLogin();

                    // 区域列表
                    const regionRes = await getRegionStoreList();
                    this.regionList = regionRes.data;

                    // 如果没有区域，则自动查询门店列表（主任用）；如果有区域，则根据区域查询门店列表（区经）
                    if (loginRes.data.region) {
                        this.checkedRegion.name = loginRes.data.region?.storeName; // 当前区域
                        this.checkedRegion.id = loginRes.data.region?.id;

                        // 门店列表
                        const params = {
                            id: this.checkedRegion.id
                        };
                        const storeRes = await getRegionStoreList(params);
                        this.regionStoreList = storeRes.data;
                    }

                    if (loginRes.data.store) {
                        this.checkedStore.name = loginRes.data.store.storeName; //当前门店
                        this.checkedStore.id = loginRes.data.store.id;
                    }
                    if (!loginRes.data.region) {
                        await this.getStoreList();
                    }
                    // 所有异步操作完成后执行 onLoad
                    await this.onLoad();

                } catch (error) {
                    Toast({ position: 'top', message: error?.message || '加载失败' });
                }
            },
            //资产饼图加载
            onLoad() {
                this.getPie().then(() => {
                    let data = []
                    let radius = []
                    data = [
                        { value: this.storageAssetsList.stockOnhandCnt3, name: '{t|' + this.storageAssetsList.stockOnhandRate3 + '%' + ' \n}' + '{c|0-3个月\n' + this.storageAssetsList.stockOnhandCnt3 + '}', itemStyle: { color: '#f9b59f' }, monthId: 1 },
                        { value: this.storageAssetsList.stockOnhandCnt6, name: '{t|' + this.storageAssetsList.stockOnhandRate6 + '%' + ' \n}' + '{c|4-6个月\n' + this.storageAssetsList.stockOnhandCnt6 + '}', itemStyle: { color: '#5678ff' }, monthId: 2 },
                        { value: this.storageAssetsList.stockOnhandCnt9, name: '{t|' + this.storageAssetsList.stockOnhandRate9 + '%' + ' \n}' + '{c|7-9个月\n' + this.storageAssetsList.stockOnhandCnt9 + '}', itemStyle: { color: '#f56c40' }, monthId: 3 },
                        { value: this.storageAssetsList.stockOnhandCnt12, name: '{t|' + this.storageAssetsList.stockOnhandRate12 + '%' + ' \n}' + '{c|10-12个月\n' + this.storageAssetsList.stockOnhandCnt12 + '}', itemStyle: { color: '#72d8db' }, monthId: 4 },
                    ]
                    //筛选 默认值
                    this.checkedMonth = this.monthOpt[0]
                    radius = ['30%', '60%']
                    // 基于准备好的dom，初始化echarts实例
                    this.myEcharts = this.$echarts.init(this.$refs.headchart);
                    window.onresize = this.myEcharts.resize;
                    let options = {
                        series: [
                            {
                                type: 'pie',
                                radius: radius,
                                // avoidLabelOverlap: false,  //备注隐藏
                                label: {
                                    show: true,
                                    // color: "#35434C",
                                    bleedMargin: 0, //
                                    rich: {
                                        c: {
                                            padding: [8, 0, 0, 0],
                                            fontSize: window.innerWidth * 26 / 750,
                                            color: "#35434C",
                                            align: 'left',
                                        },
                                        t: {
                                            fontSize: window.innerWidth * 32 / 750,
                                        }
                                    },
                                },
                                labelLine:
                                {
                                    normal: {
                                        length: 20,
                                        length2: 20,
                                        lineStyle: {
                                            width: 2//设置线条粗细
                                        }
                                    }
                                },
                                data: data
                            }
                        ]
                    };
                    const that = this
                    this.myEcharts.on('click', function (param) { //添加点击事件
                        that.checkedMonth = that.monthOpt.find(item => item.id === param.data.monthId)
                        that.getDetail()
                    });
                    this.myEcharts.setOption(options);
                }).then(() => {
                    this.getDetail();
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                });

            },
            //饼图
            getPie() {
                const params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id,
                    type: this.typeVal.id
                }
                return request({
                    url: '/dwsscskuexpireddi/view',
                    method: "get",
                    params: params
                }).then((res) => {
                    this.storageAssetsList = res.data;
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            onRefresh() {
                this.refreshing = false;
                this.onLoad();
            },
            //明细
            getDetail() {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0
                });
                const params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id,
                    type: this.typeVal.id,
                    onhand: this.checkedMonth.id,
                    sortType: this.sortVal ? '2' : '1'
                }
                return request({
                    url: `/dwsscskuexpireddi/viewDetails`,
                    method: "get",
                    params: params
                }).then((res) => {
                    this.detailList = res.data;
                    Toast.clear();
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            //选区域
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: 0
                    }
                    saveRegionStore(params).then((res) => {
                        // location.reload()
                        this.init()
                    })
                })
                // this.myEcharts.dispose();
                // this.onLoad();
            },
            //选门店
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                this.myEcharts.dispose();
                this.onLoad();
            },
            //切换类型
            changeTypeEvt(data) {
                this.typeVal = data
                this.showType = false
                this.myEcharts.dispose();
                this.onLoad();
            },
            sortEvt: debounce(function (data) {
                this.sortVal = !this.sortVal
                this.getDetail()
            }, 1000, { 'leading': true, 'trailing': false }),
            //切换月份
            changeMonth: debounce(function (data) {
                this.checkedMonth = data
                this.showMonth = false
                this.getDetail()
            }, 1000, { 'leading': true, 'trailing': false }),
            // 获取门店列表
            async getStoreList() {
                try {
                    const res = await request({
                        url: '/employeeStore/getEmployeeAllStore',
                        method: "get",
                    });
                    this.regionStoreList = res.data;
                    console.log(this.checkedStore)
                    if (Object.keys(this.checkedStore).length === 0) {
                        this.checkedStore = res.data && res.data.length > 0 && res.data[0];
                    }
                } catch (error) {
                    Toast({ position: 'top', message: error ?? '' });
                    throw error;
                }
            }
        },
    };
</script>

<style scoped lang="less">
    .store-box {
        padding: 30px 30px;
        height: 118px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .type-name-box {
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    .head-box {
        width: 750px;
        height: 248px;
        background: #f5f6f7;
        padding: 30px;

        .assets {
            margin-top: 30px;
        }

        .title-name {
            height: 48px;
            font-size: 34px;
            color: #35434c;
            line-height: 48px;
            margin-top: 22px;
            display: flex;
            justify-content: space-between;

            span {
                &:last-of-type {
                    font-size: 26px;
                    color: #a0acb5;
                }
            }
        }

        .amount {
            height: 70px;
            font-size: 50px;
            font-weight: 700;
            color: #35434c;
            line-height: 70px;
        }

        .detail-box {
            width: 253px;
            height: 60px;
            background: #2fd0d5;
            border-radius: 45px;
            justify-content: center;
            margin-left: 20px;
        }

        .detail-name {
            height: 40px;
            font-size: 28px;
            color: #ffffff;
            line-height: 40px;
        }

        .head-arrow {
            width: 15px;
            height: 26px;
            font-size: 28px;
            color: #ffffff;
            margin-left: 10px;
        }
    }

    .storageassets-module {
        height: 100%;
        overflow-y: auto;
        padding-bottom: 30px;
    }

    .head-chart {
        height: 570px;
    }

    #headchart {
        height: 570px;
    }

    .interval {
        width: 750px;
        height: 20px;
        background: #f2f2f5;
        opacity: 0.5;
    }

    .date-box {
        padding: 30px;

        .date {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            color: #35434c;
        }

        .sort {
            font-size: 28px;
        }

        .arrow-l {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-right: 30px;
        }

        .arrow-r {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-left: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-left: 30px;
        }

        .arrow-b {
            width: 0;
            height: 0;
            border-top: 10px solid #35434c;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            margin-left: 30px;
        }

        .arrow-t {
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #35434c;
            margin-left: 30px;
        }

        .updatetime {
            height: 37px;
            font-size: 26px;
            color: #a0acb5;
            line-height: 37px;
        }
    }

    .dataListWrapper {
        box-sizing: border-box;
        padding: 0 30px;

        .dataListBox {
            border-bottom: 1px solid #d7d7d7;

            &:last-of-type {
                border: 0;
            }

            .title {
                font-size: 32px;
                color: #35434c;
                margin: 20px 0;
                font-weight: 500;
            }

            .desc {
                font-size: 28px;
                color: #a0acb5;
                margin: 20px 0;
            }

        }
    }

    .van-pull-refresh {
        min-height: 100%;
    }
</style>
